import type {
    PermissionPayload,
    PermissionResponse,
} from '@/types/apps/permission.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';
import type { Indexable } from '@/types/service/indexable.interface';

type PermissionListResponse = ApiResponse<PaginatedResult<PermissionResponse>>;

export class PermissionService
    implements
        Indexable<PermissionListResponse>,
        Creatable<ApiResponse<PermissionListResponse>>
{
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/admin/permissions',
    };

    public index(params?: QueryParams): Promise<PermissionListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }

    public create(
        payload: PermissionPayload
    ): Promise<ApiResponse<PermissionListResponse>> {
        return this.apiClient.postApi(this.endpoints.base(), payload);
    }
}
